import React from 'react';
import { Box } from '@mui/material';
import { keyframes } from '@mui/system';

const ripple = keyframes`
  0% { transform: scale(1); opacity: 0.55; }
  70% { transform: scale(2.6); opacity: 0; }
  100% { transform: scale(2.6); opacity: 0; }
`;

export interface LiveDotProps {
  /** Diameter in px. */
  size?: number;
}

/**
 * Something is happening right now: a green dot with a ring that ripples out
 * from it. For a page that updates by itself, or an agent that is running.
 * Still, with no ripple, for anyone whose system asks for less motion.
 */
export function LiveDot({ size = 8 }: LiveDotProps) {
  return (
    <Box
      component="span"
      aria-hidden
      sx={(t) => ({
        position: 'relative',
        display: 'inline-block',
        flexShrink: 0,
        width: size,
        height: size,
        borderRadius: '50%',
        bgcolor: t.tokens.semantic.success,
        '&::after': {
          content: '""',
          position: 'absolute',
          inset: 0,
          borderRadius: '50%',
          bgcolor: t.tokens.semantic.success,
          animation: `${ripple} 1.8s ${t.ds.motion.easing.standard} infinite`,
        },
        '@media (prefers-reduced-motion: reduce)': { '&::after': { animation: 'none', opacity: 0 } },
      })}
    />
  );
}
